export default "__VITE_ASSET__D4j5N2yj__"